<template>
  <div class="item" :class="{ failed: error }">
    <label v-if="label" :for="id" class="form-control-label">
      {{ label }}
      <span v-if="required">*</span>
    </label>

    <input
      :id="id"
      type="text"
      :placeholder="`${placeholder}${!label && required ? '*' : ''}`"
      v-bind="$attrs"
      class="form-control"
      :class="{ failed: error }"
      :value="modelValue"
      :disabled="true"
      v-if="disabled"
    />
    <VueTelInput
      :inputOptions="{
        placeholder
      }"
      :defaultCountry="defaultCountry"
      :id="id"
      v-bind="$attrs"
      class="form-control"
      :class="{ failed: error }"
      :value="modelValue"
      mode="international"
      @input="onInput"
      v-else
    />
  </div>
</template>
<script>
import { VueTelInput } from 'vue3-tel-input';
import 'vue3-tel-input/dist/vue3-tel-input.css';
import parsePhoneNumber from 'libphonenumber-js/max';
import { computed } from 'vue';

export default {
  name: 'PhoneField',
  inheritAttrs: false,
  components: {
    VueTelInput
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    rules: {
      type: Array,
      default: () => {
        return [];
      }
    },
    error: {
      type: [String, Boolean],
      default: ''
    },
    allowedTypes: {
      type: Array,
      default: () => {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    modelValue: String
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const getPhoneType = (number, country) => {
      const parsed = parsePhoneNumber(number, country);
      return parsed.getType() || null;
    };

    const validate = phoneObject => {
      if (phoneObject.valid) {
        const type = getPhoneType(
          phoneObject.nationalNumber,
          phoneObject.countryCode
        );
        if (props.allowedTypes.length) {
          if (props.allowedTypes.includes(type)) {
            emit('update:modelValue', phoneObject.number.toString());
          } else {
            emit('update:modelValue', '');
          }
        } else {
          emit('update:modelValue', phoneObject.number.toString());
        }
      } else {
        emit('update:modelValue', '');
      }
    };
    const onInput = (value, phoneObject) => {
      if (phoneObject) {
        validate(phoneObject);
      }
    };

    const required = computed(() => {
      return props.rules.includes('required');
    });

    const defaultCountry = computed(() => {
      if (window.settings.default_phone_country) {
        return window.settings.default_phone_country.toUpperCase();
      }
      return 'EE';
    });

    return {
      onInput,
      required,
      defaultCountry
    };
  }
};
</script>
